
<script>
import { mapGetters } from "vuex"
import VueCharts from "vue-chartjs"
import { Line, mixins } from "vue-chartjs"

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  data: function() {
    return {
      options: {
        tooltips: {
          callbacks: {
            label: item => `${item.yLabel}`
          }
        },
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                unit: "day",
                unitStepSize: 1,
                displayFormats: {
                  day: "MMM DD"
                }
              }
            }
          ],
          yAxes: [
            {
              id: "COUNT",
              type: "linear",
              position: "left",
              scaleLabel: {
                display: true,
                labelString: "COUNT"
              }
            },
            {
              id: "USD",
              type: "linear",
              position: "right",
              scaleLabel: {
                display: true,
                labelString: "USD"
              },
              gridLines: {
                display: false
              }
            }
          ]
        }
      }
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}
</script>


// WEBPACK FOOTER //
// resources/js/components/dashboard/GraphProfitTradeChart.vue